export const detail = {
    routeTitle: '当前场所成员列表',
    listOfUsers: '成员列表',
    homeDetail: '详情',
    metersLabel: '监控器',
    usersLabel: '场所用户',
    siteConfig: '站点配置',
    noUsersLabel: '所选场所没有成员',
    detailRouteTitle: '场所详情',
    detailRoute: '详情',
    detailInformationTitle: '场所信息',
    deleteConfirmTitle: '确定要删除该场所?',
    deleteConfirmDescription: ['该场所', '将被永久删除'],
    // Meters
    addMeterButton: '添加新监控器',
    addMeterModalTitle: '添加新监控器类别',
    addDeviceModalTitle: '添加新设备',
    addDeviceButton: '添加设备',
    editDeviceModalTitle: '编辑设备',
    canNotFetchDevicesForDeletedMeter: '无法获取已删除监控器的所属设备.',
    deleteDeviceModalTitle: '确定删除当前监控器上的该设备?',
    deleteDeviceConfirmDescription: [
        '当前监控上的设备',
        '此操作后将被删除'
    ],
    undeleteDeviceOrMeter: '将在此次操作后更新.',
    deleteMeterModalTitle: '你确定要删除此监控器吗？',
    deleteMeterConfirmDescription: ['监控器', '此操作后将被删除.'],
    editMeterModalTitle: '编辑监控器详情',
    editDeviceButton: '编辑设备',
    meterName: "监控器名称",
    capacity: '容量',
    installationDate: '安装日期',
    meterMacAddress: 'MAC地址',
    meterMacAddressFormatField:
        'Mac地址格式无效. 允许 a-f A-F 和 0-9. 允许12个字符.',
    meterIpAddress: 'IP地址',
    meterUrl: '网址',
    enphaseUser: 'Enphase User',
    enphaseSerial: 'Enphase Serial',
    meterReadingsPerMinute: '1分钟读数',
    meterType: '监控器类别',
    noDevicesOnMonitor: '当前监控器没有添加设备',
    deviceName: '设备名称',
    deviceQuality: '设备质量',
    deviceType: '设备类型',
    deviceCountLabel: '相同实例数',
    subscriptionType: '订阅类型',
    subscriptionUntil: '订阅至',
    partner: '伙伴',
    purpose: '目的',
    flavor: '变体',
    modbusId: 'Modbus Id',
    hub: '控制器',
    production: '生產',
    grid: '網格',
    usage: '用法',
    storage: '貯存',
    hubDetails: '控制器詳細信息',
    deleteMessages: '刪除消息',
    status: '地位',
    age: '年齡',
    message: '信息',
    switchStatus: '狀態',
    meterStatus: '狀態',
    noController: '-- 沒有任何 --',
    activateSupport: '激活在線支持',
    deactivateSupport: '停用在線支持',
    onlineSupportLabel: '在線支持',
    onlineSupportUnknown: '未知',
    onlineSupportActive: '積極的',
    onlineSupportNotActive: '不活躍',
    errorAlertTitle: '警告',
    errorAlertMessage: '該設備連接到開關。刪除前請刪除交換機或移除設備。',
    triggerUpdateWaPi: '更新 WA-PI',
    triggerUpdateWaSem: '更新 WA-SEM',
    triggerUpdateMeterSupport: '更新儀表支持',
    triggerUpdateEvcc: '更新 Evcc',
    triggerReadCompleteConfig: '读取完整配置',
    triggerReboot: '重启',
    triggerRestartWaPi: '重新启动 Wa-Pi',
    triggerRestartWaSem: '重新启动 Wa-Sem',
    triggerRestartWaMeterSupport: '读取完整配置重新启动 Wa-Meter 支持',
    triggerInstallLogConfigs: 'Install log-configs',
    triggerInstallLog2Ram: 'Install log2ram',
    mergeModalTitle1: '將"',
    mergeModalTitle2: '"合併為：',
    mergeModalOk: '合併',

    // Users
    invitedUsers: '邀请成员',
    owner: '所有者',
    userName: '名称',
    userSurname: '名',
    userEmail: '邮箱地址',
    addUser: '添加新成员',
    sureToDeleteContent: '已删除的邀请邮件: ',
    sureToDeleteHelp: '如需确认，请插入用户名',

    modbusStateFunctionCode: "状态的 Modbus 功能代码",
    modbusStateRegisterStartAddress: "状态的 Modbus 寄存器起始地址",
    modbusStateRegisterQuantity: "状态的 Modbus 寄存器数量",
    modbusStateMinValue: "状态的 Modbus 最小值",
    modbusStateMaxValue: "状态的 Modbus 最大值",
    modbusStateDataType: "状态的 Modbus 数据类型",
    modbusStateFactor: "状态的 Modbus 因子（将乘以最小值和最大值）",

    modbusWattFunctionCode: "用于读取瓦特值的 Modbus 功能代码",
    modbusWattRegisterStartAddress: "用于读取瓦特值的 Modbus 寄存器起始地址",
    modbusWattRegisterQuantity: "用于读取瓦特值的 Modbus 寄存器数量",
    modbusWattDataType: "用于读取瓦特值的 Modbus 数据类型",
    modbusWattFactor: "读取瓦特值的 Modbus 系数",

    modbusTempFunctionCode: "用于读取温度值的 Modbus 功能代码",
    modbusTempRegisterStartAddress: "用于读取温度值的 Modbus 寄存器起始地址",
    modbusTempRegisterQuantity: "用于读取温度值的 Modbus 寄存器数量",
    modbusTempDataType: "用于读取温度值的 Modbus 数据类型",
    modbusTempFactor: "用于读取温度值的 Modbus 系数",
    meterA: "仪表A",
    meterB: "量规 B",
    meterSoc: "充电状态测量装置",
    solaxRegistrationNr: "Registration number",
    neoomBeaamApiKey: 'Key for BEAAM API',
};